import React from "react";
import { IconProps } from "..";

export default (props: IconProps) => (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6 9.111 1 4.086c.082-.19.198-.378.35-.562.15-.184.332-.359.544-.524l4.094 4.16L9.996 3c.216.17.407.344.573.524.166.18.31.367.431.562L6 9.111z"
            fill="#706F6F"
            fillRule="evenodd"
        />
    </svg>
);
